export function normalizePackagesMeta(raw) {
    if (Array.isArray(raw)) {
        return raw;
    }
    if (raw && typeof raw === "object") {
        return Object.values(raw);
    }
    return [];
}
